/**
 * View for the END voyage entry.
 */
var VRC = VRC || {};
VRC.VoyageLogEntryEndView = function () {
	var $view, _voyage;

	var init = function () {

		_voyage = VRC.CurrentVoyage.getCurrentVoyage();

		var allPorts = VRC.MasterDataService.getGroupedPorts();

		var voyageJson = _voyage.toJson();

		//Combine all info needed to render the event log.
		var data = {
			fuelTankInfo: VRC.CurrentVoyage.getFuelTankInfo(),
			allPorts: allPorts,
			voyage: voyageJson,
            inside500mZonePosition : VRC.MasterDataService.getInside500mZonePosition()

		};

		var $row = $(WELL.Handlebars.VRC.end_voyage_event_log(data));

		attachEventHandlers($row);
		validateEndDate(data.voyage.to_dateTime, $row);
		initSelectize($row);
		$view = $row;

	};

	var initSelectize = function ($row) {
		var $l_port_box = $row.find('.log_entry_place');
		//$l_port_box.selectize(VRC.Utils.Selectize.getConfig());
	};

	var initDatepicker = function ($row) {

		var $datetimeCell = $row.find('.table__dateTime');
		$datetimeCell.datetimepicker({
			format: g_timeStampFormat,
			showTodayButton: true
		});

	};

	var attachEventHandlers = function ($row) {
		onPortChange($row);
		onNumberChange($row);
		initDatepicker($row);
		onDateTimeChange($row);
		onEndMission($row);
	};

	var onNumberChange = function ($row) {
		$row.find('.log_entry_deck_numbers').each(function () {
			SetInputNumbersOnly(this);
		});
	};

	var onPortChange = function ($row) {
		var port = _voyage.getToPort();
		var $portBox = $row.find('.log_entry_place');
		$portBox.val((port === undefined ? g_voyage_planning.GetPreviousPort() : (port == null ? 0 : port) )).change();
		$portBox.change(function () {
			$(this).css('border', '1px solid gray');
			var value = $(this).children('option:selected').val();
			_voyage.setToPort(value);
		});
	};

	var onDateTimeChange = function ($row) {
		var $datePicker = $row.find('.table__dateTime');
		var backupDate;

		$datePicker.on('focus', function () {
			backupDate = $(this).val();
		});

		$datePicker.on('dp.hide', function () {
			$('#event_log_table').trigger("appendCache");
			$('#event_log_table').trigger("update");

			var date = $(this).val();

			_voyage.setToDateTime(date);

			var $cell = $datePicker.closest('td');
			validateEndDate(date, $row, $cell);
		});

	};

	var onEndMission = function ($row) {
		var $currentVoyageEndBtn = $row.find('#log_entry__end-btn');
		$currentVoyageEndBtn.unbind('click').click(function () {
			var currentVoyage = VRC.CurrentVoyage.getCurrentVoyage();
			currentVoyage.save();
			currentVoyage.getWarnings();
			g_voyage_planning.DisplayValidations();
		});
	};



	var toggleVoyageBtn = function (status, $row) {
		var $btn = $row.find("#log_entry__end-btn");

		$btn.prop("disabled", !status);
	};

	var validateEndDate = function (value, $row, $cell) {

		var isValidDate = moment(value, [g_timeStampFormat], true).isValid();

		if (value === '' || value === undefined) {
			toggleVoyageBtn(false, $row);
		}
		else if (isValidDate) {
			toggleVoyageBtn(true, $row);

		}
		else {
			toggleVoyageBtn(false, $row);
		}
	};

	var getView = function () {
		return $view;
	};

	init();

	return {
		init: init,
		getView: getView

	}
};
